export default __webpack_public_path__ + "static/media/trenza-pelirrojo.62cce667.png";